import { Page } from '../../../components';
import { JobsList } from './JobsList';

export const ManageJobsPage = () => {
  return (
    <Page title="Manage Jobs">
      <JobsList />
    </Page>
  );
};
